import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import FormattedListValue from '@/shared/components/FormattedListValue';
import classNames from 'classnames';
import intlShape from '@/shared/utils/intlShape';
import messages from './documentTemplateMessages';
import { useExamples } from './examples';

const ExampleLanguageColumn = ({ intl, languageCode, examples }) => {
  if (examples.length === 0) return <div className="col-md-4" />;

  return (
    <div className="col-md-4">
      <FormattedListValue list="language" id={languageCode} />
      <ul className="list-unstyled example-list">
        {examples.map(e => (
          <li key={e.label}>
            <a
              href={e.url}
              target="_blank"
              // className="text-nowrap"
              rel="noopener noreferrer"
              title={intl.formatMessage(messages.Download)}
            >
              <i className="fa fa-download fa-fw" />
              <span>{e.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
ExampleLanguageColumn.propTypes = {
  intl: intlShape.isRequired,
  languageCode: PropTypes.oneOf(['nl', 'fr', 'en']).isRequired,
  examples: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
};
ExampleLanguageColumn.defaultProps = {
  examples: [],
};

const DocumentTemplateExamples = ({
  intl,
  className,
  languageCode,
  templateType,
  search,
  tenantConfiguration,
  tenantLanguages,
}) => {
  const { examples, languages } = useExamples(
    tenantConfiguration,
    tenantLanguages,
    languageCode,
    templateType,
    search,
  );

  return (
    <div className={classNames('container-fluid', className)}>
      {examples.map(({ category, message, items }) => (
        <div key={category}>
          <div className="row">
            <div className="col-md-12">
              <label className="bold">
                <FormattedMessage {...message} />
              </label>
            </div>
          </div>
          <div className="row">
            {languages.map(l => (
              <ExampleLanguageColumn
                languageCode={l}
                key={l}
                examples={items.filter(t => t.languageCode === l)}
                intl={intl}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

const languageCodePropType = PropTypes.oneOf(['nl', 'fr', 'en']);
DocumentTemplateExamples.propTypes = {
  intl: intlShape.isRequired,
  search: PropTypes.string,
  className: PropTypes.string,
  languageCode: languageCodePropType,
  templateType: PropTypes.number,
  tenantConfiguration: PropTypes.number.isRequired,
  tenantLanguages: PropTypes.arrayOf(languageCodePropType).isRequired,
};
DocumentTemplateExamples.defaultProps = {
  className: null,
  languageCode: null,
  templateType: null,
  search: '',
};

export default DocumentTemplateExamples;
